import React, { useEffect, useState } from 'react';
import { AIMCPDashboard } from '../components/ai-mcp/AIMCPDashboard'
import { MobileAIMCP } from './MobileAIMCP';

export const AIMCPPage: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024); // Match lg breakpoint
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (isMobile) {
    return <MobileAIMCP />;
  }

  return (
    <div className="space-y-6">
      <AIMCPDashboard />
    </div>
  );
};